import { useRef, useCallback, useEffect } from 'react';
// timeout that automatically cancels itself when its parameters change
// obviously this means you need to use useCallback to define the callback
// returns a callback to manually cancel the timeout if needed
export function useTimeout(callback, delay, isEnabled) {
    if (isEnabled === void 0) { isEnabled = true; }
    var timeoutHandle = useRef();
    var resetTimeout = useCallback(function () {
        if (timeoutHandle.current) {
            clearTimeout(timeoutHandle.current);
            timeoutHandle.current = undefined;
        }
    }, []);
    useEffect(function () {
        if (!isEnabled) {
            return;
        }
        timeoutHandle.current = setTimeout(callback, delay);
        return resetTimeout;
    }, [callback, delay, resetTimeout, isEnabled]);
    return resetTimeout;
}
//# sourceMappingURL=useTimeout.js.map